
if (App.Eros.Config.design.useStickyCTA) {
    $(document).ready(function() {

        $(".mobile-sticky").each(function() {
            // eslint-disable-next-line no-invalid-this
            $("<div class='sticky-anchor' style='display:block; height: 0px;'></div>").insertBefore(this);

            // eslint-disable-next-line no-invalid-this
            if ( $(this).css("order") ) {
                // eslint-disable-next-line no-invalid-this
                const stickyOrder = $(this).css("order");

                $(".sticky-anchor").css("order", stickyOrder);
            }
        });

        const stickyObject = $(".mobile-sticky");
        const stickyAnchor = $(".sticky-anchor");
        const stickyHeight = stickyObject.height();

        let isRegistered = false;

        function stickyElements() {

            if (stickyAnchor.length) {
                const windowPos = $(window).scrollTop() + $(window).height();
                const stickyPos = stickyAnchor.offset().top + stickyHeight;

                if (windowPos < stickyPos) {
                    $(".mobile-sticky").addClass("active-sticky");
                } else {
                    $(".mobile-sticky").removeClass("active-sticky");
                }
            }
        }

        function initListener() {
            if (window.innerWidth <= 767 && !isRegistered) {
                isRegistered = true;
                $(document).on("scroll", function() {
                    stickyElements();
                });
            }
        }

        stickyElements();
        initListener();

        $(window).resize(function() {
            initListener();
        });

    });
}